module.exports = "pegasus_template/assets/blocks/column-6-theme5.png";